export { parseDom } from 'src/frontend-lib/tools/domUtil'
export { loadStyle } from 'src/frontend-lib/tools/loadStyle'
export { loadScript } from 'src/frontend-lib/tools/loadScript'
export { toHHmmss } from 'src/frontend-lib/tools/time'



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/utils/index.js